import React from 'react';
import { observer } from 'mobx-react';

import { EmailIcon } from 'ui-brand/components/icons';
import PasswordInput from 'ui-brand/components/PasswordInput';
import PhoneInput from 'ui-brand/components/PhoneInput';
import TextInput from 'ui-brand/components/TextInput';

import PlatformIntegrationStore from './stores/PlatformIntegrationStore';

const TEXT_FIELDS = [
  { field: 'company_name', label: gettext('Store name'), autoComplete: 'organization' },
  { field: 'full_name', label: gettext('Your name'), autoComplete: 'name' },
  { field: 'email', label: gettext('Work email'), type: 'email', autoComplete: 'email', icon: <EmailIcon /> },
] as const;

function PlatformIntegrationForm({ store }: { store: PlatformIntegrationStore }) {
  return (
    <>
      {TEXT_FIELDS.filter(({ field }) => store.fields.includes(field)).map(({ field, label, ...props }) => (
        <TextInput
          key={field}
          label={label}
          required
          name={field}
          value={store.data[field]}
          onChange={(value) => store.updateData({ [field]: value })}
          error={store.errors[field]}
          {...props}
        />
      ))}
      <PasswordInput
        label={gettext('Password')}
        required
        name="password"
        placeholder={gettext('Choose a password')}
        autoComplete="new-password"
        value={store.data.password}
        onChange={(value) => store.updateData({ password: value })}
        error={store.errors.password}
      />
      {store.fields.includes('phone_number') && (
        <PhoneInput
          label={gettext('Phone')}
          optionalHint={gettext('(optional)')}
          country={store.phoneCountry}
          onCountryChange={store.setPhoneCountry}
          value={store.data.phone_number}
          onChange={(value) => store.updateData({ phone_number: value })}
          error={store.errors.phone_number}
        />
      )}
    </>
  );
}

export default observer(PlatformIntegrationForm);
